/*
 * Storefront enhancements. Everything works without this file:
 * - product gallery: first image shows; thumbnails need JS to swap
 * - FAQ tabs: hidden without JS, groups render stacked with headings
 * - cart +/- buttons: quantity inputs + noscript Update button work natively
 */
(function () {
  'use strict';

  /* product gallery */
  var main = document.querySelector('[data-tt-gallery-main]');
  if (main) {
    document.querySelectorAll('[data-tt-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.getAttribute('data-full');
        document.querySelectorAll('[data-tt-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', b === btn ? 'true' : 'false');
        });
      });
    });
  }

  /* FAQ tabs */
  var tabs = document.querySelector('[data-tt-tabs]');
  if (tabs) {
    tabs.hidden = false;
    var page = tabs.closest('.tt');
    if (page) page.classList.add('tt-js');
    var groups = document.querySelectorAll('[data-tt-group]');
    var show = function (id) {
      groups.forEach(function (g) { g.hidden = g.getAttribute('data-tt-group') !== id; });
      tabs.querySelectorAll('[data-tt-tab]').forEach(function (t) {
        t.setAttribute('aria-pressed', t.getAttribute('data-tt-tab') === id ? 'true' : 'false');
      });
    };
    tabs.querySelectorAll('[data-tt-tab]').forEach(function (t) {
      t.addEventListener('click', function () { show(t.getAttribute('data-tt-tab')); });
    });
    var first = tabs.querySelector('[data-tt-tab]');
    if (first) show(first.getAttribute('data-tt-tab'));
  }

  /* mobile menu: close the drawer after choosing a destination */
  var menu = document.querySelector('[data-tt-menu]');
  if (menu) {
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { menu.removeAttribute('open'); });
    });
    document.addEventListener('click', function (e) {
      if (menu.hasAttribute('open') && !menu.contains(e.target)) menu.removeAttribute('open');
    });
  }

  /* cart quantity steppers */
  var cart = document.querySelector('[data-tt-cart]');
  if (cart) {
    cart.querySelectorAll('[data-tt-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('input[name="updates[]"]');
        if (!input) return;
        var next = (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-tt-qty'), 10);
        input.value = Math.max(0, Math.min(99, next));
        cart.submit();
      });
    });
    cart.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
      input.addEventListener('change', function () { cart.submit(); });
    });
  }
})();

  /* ---- discount popup (landing only, once per session) ---- */
  // Same contract as the original storefront: 2.5s delay, dismissing marks the
  // session. The form posts natively (hCaptcha); after Shopify's redirect the
  // popup reopens on its thank-you state - but only when the popup form was
  // the one submitted, since the footer form posts to the same endpoint.
  (function () {
    var pop = document.querySelector('[data-tt-popup]');
    if (!pop || typeof pop.showModal !== 'function') return;
    var SEEN = 'tt_popup_seen', SENT = 'tt_popup_submitted';
    var get = function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } };
    var set = function (k) { try { sessionStorage.setItem(k, '1'); } catch (e) {} };
    var del = function (k) { try { sessionStorage.removeItem(k); } catch (e) {} };

    pop.addEventListener('close', function () { set(SEEN); });
    pop.querySelectorAll('[data-popup-close]').forEach(function (b) {
      b.addEventListener('click', function () { pop.close(); });
    });
    pop.addEventListener('click', function (e) { if (e.target === pop) pop.close(); });

    var form = pop.querySelector('form');
    if (form) form.addEventListener('submit', function () { set(SENT); });

    if (pop.querySelector('[data-posted]') && get(SENT)) {
      del(SENT);
      pop.showModal();
      if (window.history && window.history.replaceState &&
          window.location.search.indexOf('customer_posted') !== -1) {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
      return;
    }
    if (!get(SEEN)) {
      setTimeout(function () { if (!pop.open) pop.showModal(); }, 2500);
    }
  })();

  /* ---- discount popup: two-step reveal ---- */
  // Step 1 is the ask; Unlock swaps in the email form and focuses it (the
  // focus also warms Shopify's lazy hCaptcha before the native submit).
  (function () {
    var pop = document.querySelector('[data-tt-popup]');
    if (!pop) return;
    var next = pop.querySelector('[data-step-next]');
    var s1 = pop.querySelector('[data-step="1"]');
    var s2 = pop.querySelector('[data-step="2"]');
    if (!next || !s1 || !s2) return;
    next.addEventListener('click', function () {
      s1.hidden = true;
      s2.hidden = false;
      var em = s2.querySelector('input[type="email"]');
      if (em) em.focus();
    });
  })();

  /* ---- bag drawer (lemme-style flyout, native AJAX Cart API) ---- */
  (function () {
    var drawer = document.querySelector('[data-tt-drawer]');
    if (!drawer || typeof drawer.showModal !== 'function' || !window.fetch) return;

    var itemsEl = drawer.querySelector('[data-drawer-items]');
    var subEl = drawer.querySelector('[data-drawer-subtotal]');
    var shipWrap = drawer.querySelector('[data-drawer-ship]');
    var shipLabel = drawer.querySelector('[data-ship-label]');
    var shipPct = drawer.querySelector('[data-ship-pct]');
    var shipFill = drawer.querySelector('[data-ship-fill]');
    var freeAt = parseInt(drawer.getAttribute('data-free-ship') || '0', 10);

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
    function esc(str) {
      var d = document.createElement('div');
      d.textContent = str == null ? '' : String(str);
      return d.innerHTML;
    }
    function thumb(url) {
      if (!url) return '';
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=128';
    }

    function render(cart) {
      var counts = document.querySelectorAll('.tt-bag-count');
      counts.forEach(function (c) { c.textContent = cart.item_count; });

      if (!cart.items.length) {
        itemsEl.innerHTML =
          '<div class="tt-drawer__empty"><p class="tt-drawer__empty-title">your bag is empty!</p>' +
          '<p>Two a day starts with one bottle.</p>' +
          '<a class="tt-pill-link" href="/products/booty-growth-gummies">Shop the gummies</a>' +
          '<a class="tt-pill-link" href="/products/booty-growth-gummies#sec-ingredients">What’s inside</a>' +
          '<a class="tt-pill-link" href="/pages/help">Help &amp; FAQ</a></div>';
      } else {
        itemsEl.innerHTML = cart.items.map(function (it, i) {
          var plan = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan
            ? '<p class="tt-drawer__line-plan">' + esc(it.selling_plan_allocation.selling_plan.name) + '</p>' : '';
          return '<div class="tt-drawer__line" data-line="' + (i + 1) + '">' +
            (it.image ? '<img src="' + esc(thumb(it.image)) + '" alt="" loading="lazy">' : '') +
            '<div class="tt-drawer__line-info">' +
              '<p class="tt-drawer__line-title">' + esc(it.product_title) + '</p>' + plan +
              '<div class="tt-drawer__line-row">' +
                '<span class="tt-drawer__qty">' +
                  '<button type="button" data-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
                  '<span>' + it.quantity + '</span>' +
                  '<button type="button" data-qty="1" aria-label="Increase quantity">+</button>' +
                '</span>' +
                '<span class="tt-drawer__line-price">' + money(it.final_line_price) + '</span>' +
              '</div>' +
              '<button type="button" class="tt-drawer__remove" data-remove>Remove</button>' +
            '</div>' +
          '</div>';
        }).join('');
      }
      subEl.textContent = money(cart.total_price);

      drawer.classList.toggle('is-empty', !cart.items.length);
      if (freeAt > 0) {
        shipWrap.hidden = false;
        var pct = Math.min(100, Math.round(cart.total_price / freeAt * 100));
        var left = freeAt - cart.total_price;
        shipLabel.textContent = left > 0
          ? 'You\u2019re ' + money(left) + ' away from free shipping'
          : 'Free shipping unlocked \u2661';
        shipPct.textContent = pct + '%';
        shipFill.style.width = pct + '%';
      } else {
        shipWrap.hidden = true;
      }
    }

    function refresh(open) {
      itemsEl.setAttribute('aria-busy', 'true');
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          render(cart);
          if (open && !drawer.open) drawer.showModal();
        })
        .finally(function () { itemsEl.removeAttribute('aria-busy'); });
    }

    // bag link opens the drawer; without JS it stays a link to /cart
    document.querySelectorAll('[data-tt-bag]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        refresh(true);
      });
    });

    drawer.querySelector('[data-drawer-close]').addEventListener('click', function () { drawer.close(); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer) drawer.close(); });

    // qty / remove, delegated
    itemsEl.addEventListener('click', function (e) {
      var line = e.target.closest('[data-line]');
      if (!line) return;
      var qtyBtn = e.target.closest('[data-qty]');
      var removeBtn = e.target.closest('[data-remove]');
      if (!qtyBtn && !removeBtn) return;
      var current = parseInt(line.querySelector('.tt-drawer__qty span').textContent, 10);
      var quantity = removeBtn ? 0 : Math.max(0, current + parseInt(qtyBtn.getAttribute('data-qty'), 10));
      itemsEl.setAttribute('aria-busy', 'true');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(line.getAttribute('data-line'), 10), quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () { itemsEl.removeAttribute('aria-busy'); });
    });

    // add-to-cart opens the drawer instead of navigating; native submit is
    // the fallback when the request fails
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return refresh(true);
          })
          .catch(function () { form.submit(); })
          .finally(function () { if (btn) btn.disabled = false; });
      });
    });
  })();
